import { SELECT_BOPIS_STORE } from "../actions/select-store";

const initialState = {
  bopisStore: {},
};

const selectStore = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_BOPIS_STORE:
      return {
        ...state,
        bopisStore: action.payload,
      };
  }
  return state;
};

export default selectStore;
